﻿import clsx from 'clsx';
import React, { PropsWithChildren, Ref } from 'react';
import { BaseProps } from './BaseProps';
import { Menu } from './Menu';

export const Toolbar = React.forwardRef(
  (
    { className, ...props }: PropsWithChildren<BaseProps>,
    ref: Ref<HTMLDivElement> | undefined
  ) => <Menu className={clsx(className)} {...props} ref={ref} />
);
